import { successColor, dangerColor } from 'assets/jss/material-dashboard-pro-react';

const sendDialogStyle = () => ({
	container: {
		padding: '10px 30px',
	},
	line: {
		paddingBottom: 38,
	},
	success: {
		width: 24,
		color: successColor[0],
		marginRight: 4,
	},
	failure: {
		width: 24,
		color: dangerColor[0],
		marginRight: 4,
	},
	lineWithoutNumber: {
		paddingLeft: 1,
	},
	flex: {
		display: 'flex',
		alignItems: 'center',
	},
	request: {
		padding: '16px 0',
		alignItems: 'center',
	},
	center: {
		textAlign: 'center',
		margin: 'auto',
	},
	requestId: {
		marginTop:'15px'
	},
	failureContainer: {
		'& > div': {
			flex: 1,
			display: 'flex',
			alignItems: 'center',
		},
	},
	buttonContainer: {
		alignItems: 'end!important',
		flexDirection: 'column',
	},
	buttonContainerWrapper: {
		display: 'flex',
		alignItems: 'end!important',
		flexDirection: 'column',
	}
});

export default sendDialogStyle;
